<template>
	<div class="modal" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Cambiar dirección de entrega</h4>
				</div>
				<div class="modal-body">
					<template v-if="item">
						<template v-if="item.customer">
							<template v-if="item.customer.places">
								<template v-if="item.customer.places.length">
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>Localizaciones del cliente</label>
												<select @change="loadCustomerPlace(customerPlace)" v-model="customerPlace" class="form-control">
													<option v-for="place in item.customer.places" :value="place">{{place.name}}</option>
												</select>
											</div>
										</div>
									</div>
								</template>
							</template>
						</template>
					</template>
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label>Buscar</label>
								<input ref="inputAutocompletePlace" type="search" id="input-autocomplete-place" class="form-control" placeholder="Buscar...">
							</div>
						</div>
					</div>
					<div v-if="place" class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label>País</label>
								<input v-model="place.country" type="text" class="form-control" placeholder="País...">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group">
								<label>Comunidad autónoma</label>
								<input v-model="place.administrative_area_level_1" type="text" class="form-control" placeholder="Comunidad autónoma...">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group">
								<label>Provincia</label>
								<input v-model="place.administrative_area_level_2" type="text" class="form-control" placeholder="Provincia...">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group">
								<label>Ciudad</label>
								<input v-model="place.locality" type="text" class="form-control" placeholder="Ciudad...">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group">
								<label>Dirección</label>
								<input v-model="place.formatted_address" type="text" class="form-control" placeholder="Dirección...">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group">
								<label>Nombre</label>
								<input v-model="place.name" type="text" class="form-control" placeholder="Nombre...">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Número</label>
								<input v-model="place.street_number" type="text" class="form-control" placeholder="Número...">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Barrio</label>
								<input v-model="place.sublocality_level_1" type="text" class="form-control" placeholder="Barrio...">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group">
								<label>Código postal</label>
								<input v-model="place.postal_code" type="text" class="form-control" placeholder="Código postal...">
							</div>
						</div>

						<div class="col-md-6">
							<div class="form-group">
								<label>Latitud</label>
								<input v-model="place.lat" type="text" class="form-control" placeholder="Latitud...">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Longitud</label>
								<input v-model="place.lng" type="text" class="form-control" placeholder="Longitud...">
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button @click="update" type="button" class="btn btn-default">Guardar</button>
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-change-delivery-notes-place'
				},
				item: null,
				loading:  null,
				place: null,
				customerPlace: null,
				autocomplete: null,
			}
		},
		methods: {
			open(item) {
				this.clearData()
				if(item) {
					this.item = item
					this.place = JSON.parse(JSON.stringify(item.place))
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')

				var that = this
				setTimeout(function(){
					that.initAutocomplete()
				}, 100);
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.$emit('reload')
			},
			initAutocomplete() {
				var that = this
				this.autocomplete = new google.maps.places.Autocomplete(
					(that.$refs.inputAutocompletePlace),
					{types: ['geocode']}
				);
				this.autocomplete.addListener('place_changed', function(event) {
					var place = that.autocomplete.getPlace();
					if(place) {
						that.loadPlace(place)
					}
				})
			},
			clearData() {
				$('#input-autocomplete-place').val('')
				this.place = null
				this.customerPlace = null
			},
			clearPlaceData() {
				for(var value in this.place) {
					if(value != 'id' && value != 'status_id' && value != 'author_id') {
						this.place[value] = null
					}
				}
			},
			loadCustomerPlace(customer_place) {
				$('#input-autocomplete-place').val('')
				if(customer_place) {
					var place = customer_place
					place.id = this.place.id
					this.place = place
					customer_place = null
				}
			},
			loadPlace(place) {
				this.clearPlaceData()
				var that = this
				this.place.formatted_address = place.formatted_address
				this.place.name = place.name
				this.place.google_place_id = place.place_id
				this.place.url = place.url

				this.place.lat = place.geometry.location.lat()
				this.place.lng = place.geometry.location.lng()

				var address_components = []
				if(place.address_components) {
					place.address_components.forEach(function(element) {
						var type = element.types[0]
						var component = {
							type: type,
							value: element.long_name
						}
						address_components.push(component)
						if(type == 'country') {
							var component = {
								type: 'country_short_name',
								value: element.short_name
							}
							address_components.push(component)
						}
					})
				}
				address_components.forEach(function(element) {
					if(that.place[element.type] !== 'undefined') {
						that.place[element.type] = element.value
					}
				})
			},
			//----------------
			update() {
				this.loading = true
				this.$http.post('admin/management/delivery/notes/' + this.item.id + '/update/place', this.place)
				.then(response => {
					this.close()
					this.loading = false
					this.reload()
				}).catch(response => {
					console.log(response)
					this.loading = false
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/deliveryNotes/views/ChangePlace.vue